/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

import {
    fetchDatasetError,
    fetchDatasetPending,
    fetchDatasetSuccess
} from '../actions/datasetActions'

import { getBackend } from '../../utilities/endpoints'

const REACT_APP_BACKEND = getBackend()

function fetchDataset(datasetId) {
    return dispatch => {
        dispatch(fetchDatasetPending())
        fetch(`${REACT_APP_BACKEND}/api/v1/datasets/${datasetId}`)
            .then(res => res.json())
            .then(res => {
                console.log("RES FOR DATASET LOOKUP IS", JSON.stringify(res));
                if (res.success) {
                    dispatch(fetchDatasetSuccess(res))
                    return res;
                }
                dispatch(fetchDatasetError(res))

            })
            .catch(error => {
                dispatch(fetchDatasetError(error))
            })
    }
}

export default fetchDataset